// fileManagerService.js
import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const fileManagerService = {
  async uploadFile(formData) {
    try {
      const response = await api_fetch.postForm(
        '/v1/upload-file',
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        formData
      );

      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.error('Upload error:', error);
      throw new Error('File upload failed.');
    }
  },

  getFiles: async function () {
    return (
      await api_fetch.get(
        `/v1/file-manager/get-files`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async getSignedUrl(s3Url) {
    try {
      const urlObj = new URL(s3Url);
      const key = decodeURIComponent(urlObj.pathname.slice(1));
      const response = await api_fetch.get(
        `/v1/file-manager/signed-url?key=${encodeURIComponent(key)}`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        {}
      );
      const { url } = await response.json();
      return url;
    } catch (error) {
      console.error('Error fetching signed URL:', error);
      return s3Url;
    }
  },

  async downloadFile(fileUrl) {
    return await api_fetch.get(
      `/v1/file-manager/download-file/${fileUrl}`,
      { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
      {}
    );
  },

  async downloadAndSaveFile(imageUrl) {
    try {
      const urlObj = new URL(imageUrl);
      const s3Key = decodeURIComponent(urlObj.pathname.slice(1));
      const encodedKey = encodeURIComponent(s3Key);

      const res = await this.downloadFile(encodedKey);

      if (!res.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await res.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = s3Key.split('/').pop();
      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 100);
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  }
};

export default fileManagerService;
